/* =============================================================================
   Feed (Swipe)
   - markiert die einrastende Karte als .is-active (Text-Animation, Ken Burns)
   - lädt die nächsten Bilder vor, damit beim schnellen Scrollen nichts grau ist
   - merkt sich die Position, damit man nach dem Produktbesuch nicht oben landet
   - Pfeiltasten / Bild-hoch-runter auf Desktop
   ========================================================================== */

(function () {
  'use strict';

  var PRELOAD_AHEAD = 3;
  var HINT_KEY = 'feed:hint-seen';
  var POS_KEY = 'feed:last-index';

  function FeedSwipe(root) {
    this.root = root;
    this.track = root.querySelector('[data-feed-track]');
    this.cards = Array.prototype.slice.call(root.querySelectorAll('[data-feed-card]'));
    this.counter = root.querySelector('[data-feed-counter]');
    this.progressBar = root.querySelector('[data-feed-progress-bar]');
    this.hint = root.querySelector('[data-feed-hint]');
    this.activeIndex = -1;

    if (!this.track || !this.cards.length) return;

    var inEditor = window.Shopify && window.Shopify.designMode;
    if (root.dataset.randomize === 'true' && !inEditor) this.shuffle();
    this.observe();
    this.bindKeys();
    this.restorePosition();
    this.maybeShowHint();
  }

  /* Reihenfolge pro Besuch mischen -------------------------------------- */
  FeedSwipe.prototype.shuffle = function () {
    // Nur beim ersten Aufruf pro Session mischen, sonst springt die Reihenfolge
    // bei jeder Rückkehr auf die Seite und man verliert die Orientierung.
    var stored = sessionStorage.getItem('feed:order');
    var order;

    if (stored) {
      try { order = JSON.parse(stored); } catch (e) { order = null; }
    }

    if (!order || order.length !== this.cards.length) {
      order = this.cards.map(function (_, i) { return i; });
      for (var i = order.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = order[i]; order[i] = order[j]; order[j] = tmp;
      }
      try { sessionStorage.setItem('feed:order', JSON.stringify(order)); } catch (e) {}
    }

    var frag = document.createDocumentFragment();
    var original = this.cards.slice();
    order.forEach(function (idx) { frag.appendChild(original[idx]); });
    this.track.appendChild(frag);
    this.cards = Array.prototype.slice.call(this.track.querySelectorAll('[data-feed-card]'));
  };

  /* Aktive Karte erkennen ----------------------------------------------- */
  FeedSwipe.prototype.observe = function () {
    var self = this;

    this.io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var card = entry.target;
        var index = self.cards.indexOf(card);
        if (index === self.activeIndex) return;
        self.setActive(index, card);
      });
    }, {
      root: this.track,
      // Nur die Karte zählt, die den Großteil des Viewports füllt.
      threshold: 0.6
    });

    this.cards.forEach(function (card) { self.io.observe(card); });
  };

  FeedSwipe.prototype.setActive = function (index, card) {
    var prev = this.cards[this.activeIndex];
    if (prev) {
      prev.classList.remove('is-active');
      var pv = prev.querySelector('[data-feed-video]');
      if (pv) pv.pause();
    }

    card.classList.add('is-active');
    this.activeIndex = index;

    var vid = card.querySelector('[data-feed-video]');
    if (vid) { var p = vid.play(); if (p && p.catch) p.catch(function () {}); }

    this.preload(index);
    this.updateChrome(index);
    this.updateBackdrop(card);

    try { sessionStorage.setItem(POS_KEY, String(index)); } catch (e) {}
  };

  /* Bilder vorladen ------------------------------------------------------ */
  FeedSwipe.prototype.preload = function (index) {
    for (var i = index + 1; i <= index + PRELOAD_AHEAD; i++) {
      var card = this.cards[i];
      if (!card || card.dataset.preloaded) continue;

      var img = card.querySelector('img');
      if (img) {
        img.loading = 'eager';
        if ('fetchPriority' in img) img.fetchPriority = 'high';
      }
      var vid = card.querySelector('[data-feed-video]');
      if (vid && i === index + 1) vid.preload = 'auto';

      card.dataset.preloaded = 'true';
    }
  };

  /* Kopfzeile & Fortschritt --------------------------------------------- */
  FeedSwipe.prototype.updateChrome = function (index) {
    var total = this.cards.length;
    if (this.counter) this.counter.textContent = (index + 1) + ' / ' + total;
    if (this.progressBar) {
      this.progressBar.style.width = ((index + 1) / total * 100) + '%';
    }
  };

  /* Unscharfer Hintergrund auf Desktop ---------------------------------- */
  FeedSwipe.prototype.updateBackdrop = function (card) {
    if (!window.matchMedia('(min-width: 750px)').matches) return;
    var img = card.querySelector('img');
    var src = img && (img.currentSrc || img.src);
    if (src) this.root.style.setProperty('--feed-bg-image', 'url("' + src + '")');
  };

  /* Tastatur ------------------------------------------------------------- */
  FeedSwipe.prototype.bindKeys = function () {
    var self = this;
    this.track.addEventListener('keydown', function (e) {
      var dir = 0;
      if (e.key === 'ArrowDown' || e.key === 'PageDown' || e.key === ' ') dir = 1;
      if (e.key === 'ArrowUp' || e.key === 'PageUp') dir = -1;
      if (!dir) return;
      e.preventDefault();
      var next = self.cards[self.activeIndex + dir];
      if (next) next.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  };

  /* Position wiederherstellen ------------------------------------------- */
  FeedSwipe.prototype.restorePosition = function () {
    var raw;
    try { raw = sessionStorage.getItem(POS_KEY); } catch (e) { return; }
    if (raw === null) return;

    var index = parseInt(raw, 10);
    var card = this.cards[index];
    if (!card || index === 0) return;

    // Ohne smooth, damit der Sprung nicht als Animation sichtbar ist.
    var prev = this.track.style.scrollBehavior;
    this.track.style.scrollBehavior = 'auto';
    card.scrollIntoView({ block: 'start' });
    this.track.style.scrollBehavior = prev || '';
  };

  /* Wisch-Hinweis -------------------------------------------------------- */
  FeedSwipe.prototype.maybeShowHint = function () {
    if (!this.hint) return;
    var seen;
    try { seen = localStorage.getItem(HINT_KEY); } catch (e) { seen = '1'; }
    if (seen) return;

    this.hint.hidden = false;
    try { localStorage.setItem(HINT_KEY, '1'); } catch (e) {}

    var hint = this.hint;
    var hide = function () { hint.hidden = true; };
    this.track.addEventListener('scroll', hide, { once: true, passive: true });
    setTimeout(hide, 4000);
  };

  /* Init ----------------------------------------------------------------- */
  function init() {
    document.querySelectorAll('[data-feed]').forEach(function (el) {
      if (el.dataset.feedReady) return;
      el.dataset.feedReady = 'true';
      new FeedSwipe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme-Editor: Section neu geladen
  document.addEventListener('shopify:section:load', init);
})();